import React, { useEffect, useState } from "react";
interface PredictedRankCardProps {
  counselling?: string;
  year?: string;
  rank?: string;
}

const PredictedRankCard: React.FC<PredictedRankCardProps> = ({
  counselling,
  year,
  rank,
}) => {
  const totalTicks = 45;
  const currentTickIndex = Math.floor(totalTicks / 2);
  const [animatedRank, setAnimatedRank] = useState(0);

  // Counter animation logic
  // const [count, setCount] = useState(0);
  // const target = 220;
  const duration = 1000;
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (!rank || isNaN(Number(rank))) return;

    const target = Number(rank);
    let start = 0;
    const increment = target / (duration / 16); // 60 FPS

    const animate = () => {
      start += increment;
      if (start < target) {
        setAnimatedRank(Math.floor(start));
        requestAnimationFrame(animate);
      } else {
        setAnimatedRank(target);
      }
    };

    requestAnimationFrame(animate);
  }, [rank]);

  return (
    <div className="flex flex-col">
      <div className="bg-gradient-to-b from-[#052386] to-[#0B32B8] rounded-2xl p-6 w-full max-w-md mx-auto text-white relative shadow-lg">
        <div className="text-center flex flex-col gap-4">
          <h2 className="text-lg md:text-xl font-semibold">
            <strong>
              {counselling || "Predicted JEE Main Category"} - {currentYear}
            </strong>
          </h2>
          <div className="text-3xl font-bold text-white">{animatedRank}</div>{" "}
        </div>

        {/* <div className="flex justify-between items-center px-4 text-[#7A8DCC] text-sm font-medium">
          <span>198</span>
          <span>242</span>
        </div> */}

        {/* Tick bar */}
        <div className="relative mt-4 px-4">
          <div className="flex justify-between items-end h-6">
            {Array.from({ length: totalTicks }).map((_, idx) => (
              <div
                key={idx}
                className={`w-[3px] ${
                  idx === currentTickIndex
                    ? "h-8 bg-green-400"
                    : "h-6 bg-white/30"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      {/* <div className="flex flex-col">
        <p className="text-right text-[#111827] text-sm font-normal mt-4">
          Predicted JEE Main 2025 CRL Rank - 13,000
        </p>
      </div> */}
    </div>
  );
};

export default PredictedRankCard;
